define( function() {
	"use strict";

	// Only count HTML whitespace
	// Other whitespace should count in values
	// https://html.spec.whatwg.org/multipage/infrastructure.html#space-character
	return ( /[^\x20\t\r\n\f]+/g );
} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/var/rnothtmlwhite.js
// module id = 77
// module chunks = 0